import { Field, Label, Description, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { ArrayInput } from "V2.0/components/ArrayInput";
import InputComponent from "V2.0/components/InputComponent";
import { Textarea } from "V2.0/common/textarea";

import ModelsSelect, { ModelsSelectMultiple } from "./ModelsSelect";

import EvalRunConfigPersona from "./EvalRunConfig/EvalRunConfigPersona";
import EvalRunConfigExpectedEvent from "./EvalRunConfig/EvalRunConfigExpectedEvent";
import EvalRunConfigEventsToTrack from "./EvalRunConfig/EvalRunConfigEventsToTrack";

export default EvalRunConfigForm;

function EvalRunConfigForm(props) {
  const {
    formState,
    errors,
    updateFormState,
    showPremiumOptions,
    enablePremiumOptions,
    // Offers the Jarvis Labs (India deployed) models as test models; see ModelsSelect.
    showIndiaDeployedModels,
  } = props;

  return (
    <div className="space-y-8">
      <Field>
        <Label>Name</Label>
        <Description>
          What this test is called. Re-running it keeps the same name, so its
          history stays together. Left blank, it's named after the personas.
        </Description>
        <Input
          value={formState.name}
          placeholder="e.g. Refund policy — angry customer"
          onChange={(e) => updateFormState("name", e.target.value)}
        />
        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
      </Field>

      <ModelsSelectMultiple
        value={formState.modelsToTest}
        onChange={(value) => updateFormState("modelsToTest", value)}
        showPremiumOptions={showPremiumOptions}
        enablePremiumOptions={enablePremiumOptions}
        showIndiaDeployedModels={showIndiaDeployedModels}
        label="Test Models *"
        error={errors.modelsToTest}
      />

      <InputComponent
        label="Simulation Mode"
        type="select"
        value={formState.simulationMode}
        onChange={({ target: { value } }) =>
          updateFormState("simulationMode", value)
        }
        options={[
          { id: 0, value: "voice", label: "Voice" },
          { id: 0, value: "chat", label: "Chat" },
        ]}
        error={errors.simulationMode}
      />

      {formState.simulationMode === "chat" && (
        <Field>
          <Label>End Criteria</Label>
          <Textarea
            value={formState.endCriteria}
            style={{ fontSize: "13px", rows: 4 }}
            onChange={(e) => updateFormState("endCriteria", e.target.value)}
          />
          {errors.endCriteria && (
            <ErrorMessage>{errors.endCriteria}</ErrorMessage>
          )}
        </Field>
      )}

      <div>
        <EvalRunConfigPersona
          personas={formState.personas}
          error={errors.personas}
          onPersonasChange={(value) => updateFormState("personas", value)}
        />
        {errors.personas && <ErrorMessage>{errors.personas}</ErrorMessage>}
      </div>

      <Field>
        <Label>Quality Criteria *</Label>
        <Description>e.g., Tone, Empathy, Response relevance, etc.</Description>
        <ArrayInput
          values={formState.qualityCriteria}
          inputProps={{
            type: "text",
          }}
          errors={errors.qualityCriteria}
          onChange={(values) => updateFormState("qualityCriteria", values)}
        />
        {errors.qualityCriteria && (
          <ErrorMessage className="mt-1">{errors.qualityCriteria}</ErrorMessage>
        )}
      </Field>

      <div>
        <EvalRunConfigEventsToTrack
          eventsToTrack={formState.eventsToTrack}
          onEventsToTrackChange={(values) =>
            updateFormState("eventsToTrack", values)
          }
        />
      </div>

      <div>
        <EvalRunConfigExpectedEvent
          personas={formState.personas}
          eventsToTrack={formState.eventsToTrack}
          expectedEvents={formState.expectedEvents}
          onUpdateExpectedEvents={(expectedEvents) =>
            updateFormState("expectedEvents", expectedEvents)
          }
        />
      </div>

      <Field>
        <Label>Max Turns</Label>
        <Input
          type="number"
          min={1}
          value={formState.maxTurns}
          onChange={(e) => updateFormState("maxTurns", Number(e.target.value))}
          invalid={!!errors.maxTurns}
        />
        {errors.maxTurns && <ErrorMessage>{errors.maxTurns}</ErrorMessage>}
      </Field>

      <ModelsSelect
        value={formState.evaluatorModel}
        label="Evaluator Model *"
        onChange={(value) => updateFormState("evaluatorModel", value)}
        showPremiumOptions={showPremiumOptions}
        enablePremiumOptions={enablePremiumOptions}
        error={errors.evaluatorModel}
      />
      <ModelsSelect
        value={formState.customerSimulatorModel}
        label="Customer Simulator Model *"
        onChange={(value) => updateFormState("customerSimulatorModel", value)}
        showPremiumOptions={showPremiumOptions}
        enablePremiumOptions={enablePremiumOptions}
        error={errors.customerSimulatorModel}
      />
    </div>
  );
}
